/**
 * Phase 8.6 — Event Home feature flag accessor.
 *
 * Independent from the Operations Center flag so the Event Home can be
 * rolled back without disabling the bottom-mounted Operations Center
 * inside the existing EventDetail.
 *
 * Lives in its own module so tests can mock it cleanly (CRA partially
 * inlines REACT_APP_* env vars at babel-transform time — direct env
 * mutation is unreliable, a mockable module is the stable equivalent).
 */

export function isEventHomeEnabled() {
  return process.env.REACT_APP_ENABLE_EVENT_HOME === 'true';
}


/**
 * Phase 8.6A — Single source of truth for the EventDetail routing fork.
 *
 * Returns true iff the Event Home should be rendered for this event.
 * The decision is governed by:
 *   1. The frontend feature flag.
 *   2. The Operations projection's authoritative `is_pre_graduation`
 *      boolean — NOT a client-side inference from `inquiries.length`.
 *
 * Treats null / undefined / missing-projection identically to false so
 * the existing EventDetail layout renders when the projection is
 * unavailable (e.g. flag-off, 403 non-owner, transient network).
 *
 * Exported for direct unit testing — see
 * `__tests__/eventHomeFlag.test.js`.
 */
export function shouldRenderEventHome({ flagEnabled, isPreGraduation }) {
  return flagEnabled === true && isPreGraduation === true;
}
